<template>
<el-dialog :title="item.customername+'的考试数据'" :visible.sync="dialogVisible" width="80%" @close="cancel" class="special-exam-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-table :data="tableData" style="width: 100%" height="calc(100% - 52px)">
        <el-table-column prop="subjectname" label="科目名称" min-width="150px" show-overflow-tooltip>
            <template slot-scope="scope"><div class="text-ellipse">{{scope.row.subjectname ? scope.row.subjectname : '--'}}</div></template>
        </el-table-column>
        <el-table-column prop="sectionname" label="板块名称" width="120px" show-overflow-tooltip class-name="tc" label-class-name="tc">
            <template slot-scope="scope"><div class="text-ellipse">{{scope.row.sectionname ? scope.row.sectionname : '--'}}</div></template>
        </el-table-column>
        <el-table-column prop="subjectname" label="试卷名称" min-width="150px" show-overflow-tooltip>
            <template slot-scope="scope"><div class="text-ellipse">{{scope.row.exampapername}}</div></template>
        </el-table-column>
        <el-table-column label="完成情况" width="120px" class-name="tc" label-class-name="tc">
            <template slot-scope="scope">
                {{ scope.row.finishcount }}/{{ scope.row.quescount }}
            </template>
        </el-table-column>
        <el-table-column prop="rightrate" label="正确率" width="100px" class-name="tc" label-class-name="tc"></el-table-column>
        <el-table-column prop="begintime" width="150px" label="开始时间" class-name="tc" label-class-name="tc"></el-table-column>
        <el-table-column prop="submittime" width="150px" label="提交时间" class-name="tc" label-class-name="tc"></el-table-column>
        <el-table-column label="操作" width="50px" align="right" fixed="right">
            <template slot-scope="scope">
                <div class="tr">
                    <span class="separator-btn" @click.stop="handleView(scope.row)" style="color: #409eff;cursor: pointer;">
                        查看
                    </span>
                </div>
            </template>
        </el-table-column>
    </el-table>
    <el-pagination background @current-change="_getList" :current-page.sync="page.page" :page-size="page.pageSize"
        :pager-count="11" layout="prev, pager, next" :total="total">
    </el-pagination>
</el-dialog>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getQuestionbankuserexaminfo} from 'api/questionApi'

export default {
    name: 'specialExamDialog',
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            item: {
                customername: ''
            },
            param: {
                examcode: this.$route.query.examcode,
                customerinnerid: ''
            },
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            total: 0
        }
    },
    mounted() {
    },
    methods: {
        handleView(row) {
            this.$router.push({name: 'MarkingDetails', query: {id: row.examid}})
        },
        cancel() {
            this.dialogVisible = false
        },
        openDialog(row) {
            this.item = row
            this.param.customerinnerid = row.customerinnerid
            this.tableData = []
            this._getList()
            this.dialogVisible = true
        },
        _getList() {
            this.setLoading(true)
            getQuestionbankuserexaminfo({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.special-exam-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    .el-dialog {
        margin: 0 !important;
        height: 80vh;
        .el-dialog__body {
            height: calc(80vh - 55px);
            box-sizing: border-box;
        }
    }
    .tc {
        .cell {
            text-align: center;
        }
    }
}
</style>
